import React from 'react';
import './Scale.css';

export default ({ id, type }) => {
  let data = [
    {
      title: 'Totalmente falso',
      text: 'La frase no es verdadera'
    },
    {
      title: 'Ambiguo',
      text:
        'La afirmación contiene elementos verdaderos, pero obvia información que dejaría una impresión muy diferente'
    },
    {
      title: 'Impreciso',
      text:
        'La afirmación es parcialmente verdadera: obvia detalles importantes o emplea información fuera de contexto'
    },
    {
      title: 'Verdadero, pero...',
      text:
        'La afirmación es verdadera pero requiere información para darle consistencia'
    },
    {
      title: 'Totalmente verdadero',
      text:
        'La afirmación es verdadera, consistente y está respaldada en datos verificables'
    }
  ];

  return id
    ? {
        legend: (
          <div className="scale scale--legend">
            <div className={`scale--legend__circle scale-color--${id}`} />
            <div className="scale--legend__title">{data[id - 1].title}</div>
          </div>
        ),
        complete: (
          <div className="scale scale--complete">
            <div className={`scale--complete__title scale-color--${id}`}>
              {data[id - 1].title}
            </div>
            <div className="scale--complete__text">{data[id - 1].text}</div>
          </div>
        )
      }[type]
    : null;
};



// WEBPACK FOOTER //
// ./src/components/Scale.js